import { toast, ToastOptions } from 'react-toastify';

/**
 * Centralized toast service for consistent notifications across the app
 */
export class ToastService {
  private static defaultOptions: ToastOptions = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  /**
   * Show success toast
   */
  static success(message: string, options?: ToastOptions) {
    toast.success(message, { ...this.defaultOptions, ...options });
  }

  /**
   * Show error toast
   */
  static error(message: string, options?: ToastOptions) {
    toast.error(message, { ...this.defaultOptions, ...options });
  }

  /**
   * Show info toast
   */
  static info(message: string, options?: ToastOptions) {
    toast.info(message, { ...this.defaultOptions, ...options });
  }

  /**
   * Show warning toast
   */
  static warning(message: string, options?: ToastOptions) {
    toast.warning(message, { ...this.defaultOptions, ...options });
  }

  /**
   * Show default toast
   */
  static default(message: string, options?: ToastOptions) {
    toast(message, { ...this.defaultOptions, ...options });
  }

  /**
   * Dismiss all toasts
   */
  static dismiss() {
    toast.dismiss();
  }
}
